import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import { WELCOME_POPUP_URL, WELCOME_POPUP_STATUS_URL } from '../config/index';

import {
  GET_WELCOME_APP,
  GET_WELCOME_APP_SUCEESS,
  GET_CUSTOME_SELECT_POP_STATUS,
  GET_CUSTOME_SELECT_POP_STATUS_SUCEESS,
} from '../constants/welcomePopUp';

function* fetchGetWelcomApp() {
  try {
    const installedSoftInit = yield select(state => state.native.installedSoftInit);
    const axios = yield createAxios();
    const res = yield axios.get(WELCOME_POPUP_URL);
    if (res.data.status === 0) {
      const { appsResult } = res.data.data;
      const apps = [];
      if (appsResult) {
        appsResult.apps.forEach(item => {
          const found = installedSoftInit.find(
            soft => soft.softID === item.softID || soft.SoftID === item.softID,
          );
          if (found === undefined) {
            apps.push({ ...item, isChecked: true });
          }
        });
      }
      yield put({
        type: GET_WELCOME_APP_SUCEESS,
        payload: apps,
        judgeValue: res.data.data.needShow,
        dateNum: res.data.data.closingTimes,
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchGetCustomeSelectPopStatus({ opcode }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.post(WELCOME_POPUP_STATUS_URL, { opcode });
    if (res.data.status === 0) {
      yield put({ type: GET_CUSTOME_SELECT_POP_STATUS_SUCEESS });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchGetWelcomApp() {
  yield takeLatest(GET_WELCOME_APP, fetchGetWelcomApp);
}

export function* watchFetchGetCustomeSelectPopStatus() {
  yield takeLatest(GET_CUSTOME_SELECT_POP_STATUS, fetchGetCustomeSelectPopStatus);
}
